import translations from './fields.translations'

export const FIELD_DEFAULT_MAX_LENGTH = 254

export const FIELD_REPORTED_ERRORS = {
  INVALID: 'invalid',
  UNAUTHORIZED: 'unauthorized',
}

export const ERROR_TRANSLATIONS = {
  postalCode: {
    [FIELD_REPORTED_ERRORS.INVALID]: translations.postalCodeInvalid,
    [FIELD_REPORTED_ERRORS.UNAUTHORIZED]: translations.postalCodeUnauthorized,
  },
}

export const FIELDS_STYLE = {
  JP: {
    name: { order: 1, shouldDisplay: true },
    namePronunciation: { order: 2, shouldDisplay: true },
    company: { order: 8, shouldDisplay: true },
    country: { order: 3, shouldDisplay: true },
    city: { order: 5, shouldDisplay: true },
    state: { order: 5, shouldDisplay: false },
    street: { order: 6, shouldDisplay: true },
    streetAutocomplete: { order: 6, shouldDisplay: false },
    street2: { order: 7, shouldDisplay: true },
    postalCode: { order: 4, shouldDisplay: false },
    postalCodeAutocomplete: { order: 4, shouldDisplay: true },
    phone: { order: 9, shouldDisplay: true },
    nationalId: { order: 10, shouldDisplay: true },
  },
  US: {
    name: { order: 1, shouldDisplay: true },
    namePronunciation: { order: 2, shouldDisplay: true },
    company: { order: 3, shouldDisplay: true },
    country: { order: 8, shouldDisplay: true },
    city: { order: 6, shouldDisplay: true },
    state: { order: 7, shouldDisplay: false },
    street: { order: 4, shouldDisplay: false },
    streetAutocomplete: { order: 4, shouldDisplay: true },
    street2: { order: 5, shouldDisplay: true },
    postalCode: { order: 6, shouldDisplay: true },
    postalCodeAutocomplete: { order: 6, shouldDisplay: false },
    phone: { order: 9, shouldDisplay: true },
    nationalId: { order: 10, shouldDisplay: true },
  },
  default: {
    name: { order: 1, shouldDisplay: true },
    namePronunciation: { order: 2, shouldDisplay: true },
    company: { order: 3, shouldDisplay: true },
    country: { order: 4, shouldDisplay: true },
    city: { order: 0, shouldDisplay: false },
    state: { order: 5, shouldDisplay: true },
    street: { order: 6, shouldDisplay: false },
    streetAutocomplete: { order: 6, shouldDisplay: true },
    street2: { order: 7, shouldDisplay: true },
    postalCode: { order: 8, shouldDisplay: true },
    postalCodeAutocomplete: { order: 8, shouldDisplay: false },
    phone: { order: 9, shouldDisplay: true },
    nationalId: { order: 10, shouldDisplay: true },
  },
}

export const FIELDS_TAB_INDEX = {
  JP: {
    firstName: 2,
    lastName: 1,
    firstNamePronunciation: 4,
    lastNamePronunciation: 3,
    company: 11,
    country: 5,
    city: 8,
    stateOrProvince: 7,
    street: 9,
    streetAutocomplete: 9,
    street2: 10,
    postalCode: 6,
    postalCodeAutocomplete: 6,
    phone: 12,
  },
}
